import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {addMessage, increaseHistoryPointer, decreaseHistoryPointer} from "../../store/actions";
import { useBPMNRenderer } from "../../hooks/useBPMNRenderer";
import { FaUndo, FaRedo } from "react-icons/fa";
import ActionButton from "./ActionButton";

const NavigationButtons = () => {
  const dispatch = useDispatch();
  const history = useSelector((state) => state.history);
  const renderBPMN = useBPMNRenderer();

  const handlePrevClick = async () => {
    await dispatch(decreaseHistoryPointer());
    await handleHistoryNavigation();
  };

  const handleNextClick = async () => {
    await dispatch(increaseHistoryPointer());
    await handleHistoryNavigation();
  };

  // Handles navigation through the history by rendering the BPMN diagram
  // at the current history pointer. If rendering fails, notifies the user.
  const handleHistoryNavigation = async () => {
    try {
      // Attempt to render the BPMN diagram for the current history entry
      await renderBPMN();
    } catch (error) {
      // If rendering fails, dispatch an assistant message to inform the user
      dispatch(
        addMessage({
          sender: "assistant",
          content: `I had a problem rendering your process model: ${error}`,
        })
      );
    }
  };

  return (
    <>
      <ActionButton
        icon={FaUndo}
        tooltip="Previous"
        onClick={handlePrevClick}
        disabled={history.pointer === 0}
      />

      <ActionButton
        icon={FaRedo}
        tooltip="Next"
        onClick={handleNextClick}
        disabled={history.pointer >= history.entries.length - 1}
      />
    </>
  );
};

export default NavigationButtons;
